/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Too_LargeInputs */

const nl_tickets_too_large = /** @type {(inputs: Tickets_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bericht is te groot. Verklein of verwijder een paar afbeeldingen.`)
};

/**

* @param {Tickets_Too_LargeInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_too_large = /** @type {((inputs?: Tickets_Too_LargeInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Too_LargeInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_too_large(inputs)
});
export { tickets_too_large as "tickets.too_large" }